import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-408a1b4e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "outer" };
const _hoisted_2 = { class: "pair" };
const _hoisted_3 = { class: "flex-content" };
const _hoisted_4 = { class: "change" };
const _hoisted_5 = { class: "title display" };
const _hoisted_6 = { class: "change" };
const _hoisted_7 = { class: "title display" };
const _hoisted_8 = { class: "flex-content" };
const _hoisted_9 = { class: "change" };
const _hoisted_10 = { class: "title" };
const _hoisted_11 = { class: "content" };
const _hoisted_12 = { class: "change" };
const _hoisted_13 = { class: "title" };
const _hoisted_14 = { class: "content" };
import { useStore } from '@/store/store';
import { decimalizeByExchange } from '@/logics/utils';
import { computed, onMounted } from 'vue';
import { useMessage } from '@/const/messages';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        base: null,
        quote: null,
        pair: null
    },
    emits: ["click"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const store = useStore();
        const { format, MARKET_TITLES } = useMessage();
        const getChange = computed(() => {
            const volatility = store.state.last24Value !== 0
                ? Math.floor(((store.state.latestValue - store.state.last24Value) / store.state.last24Value) * 10000) / 100
                : 0;
            if (volatility < 0) {
                return '-' + Math.abs(volatility);
            }
            if (volatility > 0) {
                return '+' + volatility;
            }
            return '0';
        });
        let beforeLatestValue = store.state.latestValue;
        const abs = computed(() => {
            const diff = store.state.latestValue - beforeLatestValue;
            beforeLatestValue = store.state.latestValue;
            if (diff > 0) {
                return 'positive';
            }
            if (diff < 0) {
                return 'negative';
            }
            return '';
        });
        onMounted(() => {
            const current = store.state.currencyPairInfo.find((c) => c.pair === store.getters.symbol.pair);
            if (current) {
                store.state.last24High = Number(current.last24High);
                store.state.last24Low = Number(current.last24Low);
            }
        });
        const showCurrencyPair = () => {
            emits('click', true);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(props.base) + " / " + _toDisplayString(props.quote), 1),
                _createVNode(MaterialIcon, {
                    class: "icon",
                    name: "arrow_drop_down",
                    onClick: showCurrencyPair
                }),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(format)(_unref(MARKET_TITLES).MARK_PRICE)), 1),
                        _createElementVNode("div", {
                            class: _normalizeClass(["content latest_value", _unref(abs)])
                        }, _toDisplayString(_unref(decimalizeByExchange)(_unref(store).state.latestValue, props.pair, _unref(store).state.currencyPairInfo)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(format)(_unref(MARKET_TITLES).CHANGE)), 1),
                        _createElementVNode("div", {
                            class: _normalizeClass(["content", _unref(getChange).slice(0, 1) === '-' ? 'negative' : 'positive'])
                        }, _toDisplayString(_unref(getChange)) + " %", 3)
                    ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(format)(_unref(MARKET_TITLES).HIGH)), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(decimalizeByExchange)(_unref(store).state.last24High, props.pair, _unref(store).state.currencyPairInfo)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(format)(_unref(MARKET_TITLES).LOW)), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(decimalizeByExchange)(_unref(store).state.last24Low, props.pair, _unref(store).state.currencyPairInfo)), 1)
                    ])
                ])
            ]));
        };
    }
});
